module.exports = __webpack_public_path__ + "img/portrait-043.b648a473.jpg";